// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopTicketFareControllerGetCustomerTicketFaresData } from './EshopTicketFareControllerGetCustomerTicketFaresData.gen';
import type { EshopTicketFareControllerGetCustomerTicketFaresErrors } from './EshopTicketFareControllerGetCustomerTicketFaresErrors.gen';
import type { EshopTicketFareControllerGetCustomerTicketFaresResponses } from './EshopTicketFareControllerGetCustomerTicketFaresResponses.gen';
import type { Options } from './Options.gen';

export class EshopTicketFareController {
    /**
     * Get ticket fare list.
     */
    public static getCustomerTicketFares<ThrowOnError extends boolean = false>(options?: Options<EshopTicketFareControllerGetCustomerTicketFaresData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopTicketFareControllerGetCustomerTicketFaresResponses, EshopTicketFareControllerGetCustomerTicketFaresErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/ticket-fares',
            ...options
        });
    }
}
